import Utils from './utils';

/**
 * Утилиты для работы с формами
 */
const FormUtils = {
  // Получить все class для одной секции
  getSectionItems(section) {
    return section.content || [];
  },

  // Получить классы, value которых не надо
  // отправлять на сервер
  getNoValueClass() {
    return ['button', 'label', 'link', 'image'];
  },

  getAllItemClasses() {
    return [
      'edit',
      'select',
      'label',
      'image',
      'button',
      'link',
      'calendar',
      'radio',
      'check',
    ];
  },

  getFormItems(form) {
    let allItems = [];
    form.sections.forEach((section) => {
      allItems = allItems.concat(this.getSectionItems(section));
    });
    return allItems;
  },

  // Получить объект с заполнеными значения классов для всей формы
  getFormData(form) {
    const noValueClass = this.getNoValueClass();
    const isVisible = (v) => v === 'visible' || !v;
    const hasValue = (v) => {
      if (typeof v === 'object') {
        return Object.keys(v).every((key) => v[key] && v[key].length);
      }
      return !Utils.isUndefined(v);
    };
    // Формируем массив всех visible items формы
    const formItems = form.sections
      .map((i) => FormUtils.getSectionItems(i))
      .reduce((acc, i) => acc.concat(i), [])
      .filter(
        (i) =>
          !noValueClass.includes(i.class) &&
          (isVisible(i.visibility) || hasValue(i.value))
      );
    // Собираем объект key:val
    return formItems.reduce((acc, i) => ({ ...acc, [i.id]: i.value }), {});
  },

  stripHtml(str) {
    const tagsToReplace = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
    };
    return str
      .replace(/[&<>]/g, (tag) => tagsToReplace[tag] || tag)
      .replace(/\&amp\;reg\;/g, '&reg;'); // eslint-disable-line no-useless-escape
  },

  bbCodeToHtml(text = '') {
    text = this.stripHtml(text);
    const rB = /\[b\](.*?)\[\/b\]/gi;
    const rI = /\[i\](.*?)\[\/i\]/gi;
    const rU = /\[u\](.*?)\[\/u\]/gi;
    const rBr = /\[br\]/gi;
    text = text
      .replace(rB, '<b>$1</b>')
      .replace(rI, '<i>$1</i>')
      .replace(rU, '<u>$1</u>')
      .replace(rBr, '<br/>');
    return text;
  },

  // Проверка на пустое значение
  isEmptyValue(itemValue) {
    const type = typeof itemValue;
    if (type === 'object') {
      const isArray = Array.isArray(itemValue);
      if (isArray) return itemValue.length === 0;
      return Object.keys(itemValue).length === 0;
    }
    return Utils.isUndefined(itemValue);
  },

  // Добавить кнопку в форму, если нет ни одной
  addBtnToForm(form, isClosed) {
    const formItems = FormUtils.getFormItems(form);
    const findButton = formItems.find((i) => i.class === 'button');
    if (findButton) return;
    const lastSection = form.sections[form.sections.length - 1];
    lastSection.content.push({
      class: 'button',
      id: '[[addedBtn]]',
      title: 'Send',
      visibility: isClosed ? 'disabled' : 'visible',
    });
  },
};

export default FormUtils;
